// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const PlainWidgetContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.spacing80};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-bottom: ${({ theme }) => theme.spacing.spacing160};
    padding-left: ${({ theme }) => theme.spacing.spacing120};
    margin-left: ${({ theme }) => theme.spacing.spacing100};
  }
`;

export const InfoTitle = styled.div`
  text-transform: capitalize;
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-bottom: ${({ theme }) => theme.spacing.spacing10};    
`;

export const InfoContent = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;
  ${({ theme }) => theme.typography.bodyMedium};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    color: ${({ theme }) => theme.colors.textPrimary};
    ${({ theme }) => theme.typography.bodyLarge};
  }
  /* cms sends b and a tags inside html (cannot be controlled). to provide consistency */
  b {
    font-weight: 500;
  }

  a,
  a::visited {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
